export default __webpack_public_path__ + "static/media/ic_warning_triangle.442269fd.svg";